import store from '@/store'
import { getToken } from '@/utils/auth'
import { Message } from 'element-ui'
import router from '@/router'
import { debounce } from 'lodash-es'

/** 请求成功 */
export function requestResolve(config) {
  if (config.url.startsWith('/v2/')) {
    config.baseURL = process.env.VUE_APP_BASE_API_V2
    config.headers['Accept-Language'] = 'zh-CN'
  }
  if (store.getters.token) {
    // config.headers['X-Auth-Schema'] = store.getters.roles
    config.headers['Authorization'] = `Bearer ${getToken()}`
  } else {
    // config.headers['X-Auth-Schema'] = 'public'
  }
  config.headers['X-Current-Package'] = 'h5'
  return config
}
/** 请求失败 */
export function requestReject(error) {
  console.log('requestReject:', error)
  return Promise.reject(error)
}
/** 响应成功 */
export function responseResolve(response) {
  const res = response.data
  if ([200, 201].includes(response.status) && (res.code === 0 || res instanceof Blob)) {
    return res
  }
  // 状态码200但是响应code不为0
  responseReject(res)
  // return Promise.reject(res)
}
/** 响应失败 */
export const responseReject = debounce((error) => {
  console.error('responseReject:', error)
  // 返回登录页
  if (error.code === 401 || error.response?.status === 401 && router.currentRoute.path !== '/login') {
    // 重置Token
    store.dispatch('user/resetToken').then(() => router.push('/login'))
  }
  Message({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  })
  // return Promise.reject(error)
}, 150)

export default {
  requestResolve,
  requestReject,
  responseResolve,
  responseReject
}
